import { render, staticRenderFns } from "./TripSidebar.vue?vue&type=template&id=d01d4620"
import script from "./TripSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./TripSidebar.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports